export default {"src":"/_next/static/media/check-icon.8290779a.svg","height":513,"width":512};